import React, { forwardRef, Fragment, useState, useEffect } from "react";
import { Row, Col, Typography } from 'antd';
import TranslatedText from "translations/TranslatedText";
import URLConfig from './URLConfig';

export default forwardRef((props: any, ref: any) => {
  return (
    <Fragment>
      <Row type="flex" align="middle">
        <Col>
          <Typography>
            <TranslatedText id="settings.form.audio.input.label" />
          </Typography>
        </Col>
      </Row>
      <URLConfig {...props} />
    </Fragment>
  );
});
